import { Outlet } from "react-router";
import Navbar from "components/molecules/Navbar";
import Sidebar from "components/molecules/Sidebar";

// Common sidebar + Header layout
export default function MainLayout() {
  return (
    <div className="flex w-full h-screen flex-col items-start">
      <Navbar />
      {/* navbar + content */}
      <div className="bg-white flex justify-start items-start flex-grow w-full min-w-0 overflow-x-hidden min-h-0">
        <Sidebar />
        <div className="flex flex-grow flex-col self-stretch p-7 bg-white min-w-0 min-h-0 overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
